import { render } from "./ModalNewProductVideo.vue?vue&type=template&id=49f1d20c&scoped=true"
import script from "./ModalNewProductVideo.vue?vue&type=script&lang=js"
export * from "./ModalNewProductVideo.vue?vue&type=script&lang=js"

import "./ModalNewProductVideo.vue?vue&type=style&index=0&id=49f1d20c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f1d20c"]])

export default __exports__